module.exports = __webpack_public_path__ + "static/media/devices-165x165.f513cdd7.png";